
    import { mdiImport } from '@mdi/js';
    import {
        Component, Prop, Ref, Vue,
    } from 'vue-property-decorator';
    import {
        VBtn,
        VDialog,
        VDivider,
        VCard,
        VCardActions,
        VCardText,
        VCardTitle,
        // @ts-ignore
        VFileInput,
        VIcon,
        VSpacer,
        VTextarea,
    } from 'vuetify/lib';
    import Converter from '@/tunings/converter';
    import { TuningSchema } from '@/tunings/types';

    @Component({
        components: {
            VBtn,
            VDialog,
            VDivider,
            VCard,
            VCardActions,
            VCardText,
            VCardTitle,
            VFileInput,
            VIcon,
            VSpacer,
            VTextarea,
        },
    })
    export default class Import extends Vue {
        @Prop({ required: true })
        schema!: TuningSchema;

        @Ref()
        readonly importForm!: HTMLFormElement;

        iconMdiImport = mdiImport;

        importDialog = {
            show: false,
            file: [],
            raw: '',
        };

        processImport(tuning: string) {
            let parsedTuning: object;

            try {
                parsedTuning = JSON.parse(tuning);
            } catch (e) {
                this.snack('error', 'Invalid tuning');
                return;
            }

            Converter.set(this.schema, parsedTuning);

            this.snack('success', 'Tuning imported');
            this.resetImport();
        }

        resetImport() {
            this.importDialog = {
                file: [],
                raw: '',
                show: false,
            };
            this.importForm.reset();
        }

        snack(colour: string, message: string) {
            this.$emit('snack', colour, message);
        }

        upload(file: File | File[]) {
            if (!file || file instanceof Array) {
                return;
            }

            const fileReader = new FileReader();
            fileReader.onload = () => {
                if (!fileReader.result || typeof (fileReader.result) !== 'string') {
                    this.snack('error', 'Invalid tuning');
                    return;
                }

                this.processImport(fileReader.result);
            };
            fileReader.readAsText(file);
        }
    }
